import { ExpertRole } from '@declarations/common/enums/ExpertRole';
import { ListWithPagination } from '@declarations/common/pagination';
import { Reviewer } from '@declarations/models/Reviewer';
import { User } from '@declarations/models/User';
import { BaseReport } from '@declarations/models/reports/base';
import { AxiosResponse } from 'axios';

export default function setExpertUsers<T extends BaseReport>(res: AxiosResponse<ListWithPagination<T>>): AxiosResponse<ListWithPagination<T>> {
  res.data.items = res.data.items.map((baseReport: T) => {
    const clinicalReviewer = baseReport.expertReviewers.find(
      (r: Reviewer) => r.assignedRole === ExpertRole.ClinicalReviewer
    )?.user;
    baseReport.clinicalReviewer = clinicalReviewer
      ? JSON.stringify({
          id: clinicalReviewer.id,
          name: `${clinicalReviewer.firstname} ${clinicalReviewer.lastname}`,
        })
      : '';
    const legalReviewer = baseReport.expertReviewers.find(
      (r: Reviewer) => r.assignedRole === ExpertRole.LegalReviewer
    )?.user;
    baseReport.legalReviewer = legalReviewer
      ? JSON.stringify({
          id: legalReviewer.id,
          name: `${legalReviewer.firstname} ${legalReviewer.lastname}`,
        })
      : '';
    return baseReport;
  });

  return res;
}
